export const SIZES_TO_PIXELS_MAP = {
    tiny: 18,
    small: 30,
    medium: 54,
    large: 102,
};
export const SIZE_TO_STROKE_WIDTH_MAP = {
    tiny: 3,
    small: 4,
    medium: 4,
    large: 4,
};
export const SIZE_TO_ARC_ANGLE_MAP = {
    tiny: {
        light: 216,
        dark: 144,
    },
    small: {
        light: 216,
        dark: 144,
    },
    medium: {
        light: 108,
        dark: 108,
    },
    large: {
        light: 180,
        dark: 180,
    },
};
//# sourceMappingURL=Loader.constants.js.map